import Media from '@linc-technologies/linced-common/models/media';
import type { Type } from '@warp-drive/core/types/symbols';
import { belongsTo, type AsyncBelongsTo } from '@warp-drive/legacy/model';
import type Studentnotice from 'linced-learners/models/posts/studentnotice';

// Proto: media.MediaMeta.
export default class _Media extends Media {
  declare [Type]: 'media';

  @belongsTo('posts/studentnotice', { async: true, inverse: 'mediaIds' })
  declare studentNoticeId: AsyncBelongsTo<Studentnotice>;
}
